// extracted by mini-css-extract-plugin
export default {"inputs":"inputs__HHFzHb","radioGroup":"radioGroup__lJT35T","submit":"submit__NR6Jwt"};